import React, { useState, useEffect } from 'react';

interface MobileOnlyProps {
  children: React.ReactNode;
}

const MobileOnly: React.FC<MobileOnlyProps> = ({ children }) => {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);

  useEffect(() => {
    const checkMobile = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
      const isMobileViewport = window.innerWidth <= 768;
      
      // 갤럭시 폴드 펼친 상태 감지 (1536px 이상이지만 모바일 디바이스인 경우)
      // 또는 화면 비율이 가로가 더 긴 경우 (펼친 상태)
      const isGalaxyFoldUnfolded = isMobileDevice && (window.innerWidth >= 1536 || window.innerWidth > window.innerHeight);
      
      // 갤럭시 폴드 펼친 상태인 경우 PC로 인식하여 모바일이 아님으로 처리
      if (isGalaxyFoldUnfolded) {
        setIsMobile(false);
        return;
      }
      
      // 일반적인 모바일 디바이스이거나 작은 뷰포트인 경우 모바일로 처리
      setIsMobile(isMobileDevice || isMobileViewport);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  if (isMobile === null) {
    return <div>로딩 중...</div>;
  }

  if (!isMobile) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
        fontFamily: 'Arial, sans-serif',
        textAlign: 'center',
        padding: '20px'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '10px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          maxWidth: '400px'
        }}>
          <div style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#333',
            marginBottom: '20px'
          }}>
            📱 스마트폰 전용 페이지입니다
          </div>
          <div style={{
            fontSize: '16px',
            color: '#666',
            lineHeight: '1.5'
          }}>
            갤럭시 폴드는 접은 상태(세로 화면)에서 이용해주세요.<br/>
            또는 스마트폰으로 접속해주세요.
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default MobileOnly; 